import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-branches',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './branches.component.html',
  styleUrl: './branches.component.css'
})
export class BranchesComponent {
  branches = {
    name: 'Branches Management'
  };
}